import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSupportConversationDetail = async (conversationId) => {
  const token = localStorage.getItem("token");
  const { data } = await axios.get(
    `${__API_URL__}/api/support/admin/conversations/${conversationId}/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return data;
};

const useGetSupportConversationDetail = ({ conversationId, enabled = true }) => {
  return useQuery({
    queryKey: ["support_conversation_detail", conversationId],
    queryFn: () => fetchSupportConversationDetail(conversationId),
    enabled: enabled && Boolean(conversationId),
  });
};

export default useGetSupportConversationDetail;
